export function formatPrice(value) {
  if (value == null || value === 0) return "Price on Request";
  return `KES ${new Intl.NumberFormat("en-KE").format(value)}`;
}

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-KE", { year: "numeric", month: "long", day: "numeric" });
  } catch {
    return iso;
  }
}
